import axios from './setupAxios';
import Assignments from './assignments';
import Auth from './auth.js';
import Favorites from './favorites';
import Giveaway from './giveaway';
import InitialData from './initialData';
import Messages from './messages.js';
import Misc from './misc';
import Modules from './modules';
import Orders from './orders';
import Points from './points';
import Polls from './polls';
import Products from './products';
import Ads from './ads.js';
import Sharing from './sharing';
import Subscriptions from './subscriptions.js';

export default {
  version: 2,
  ads: Ads(axios),
  assignments: Assignments(axios),
  auth: Auth(axios),
  favorites: Favorites(axios),
  giveaway: Giveaway(axios),
  initialData: InitialData(axios),
  messages: Messages(axios),
  misc: Misc(axios),
  modules: Modules(axios),
  orders: Orders(axios),
  points: Points(axios),
  polls: Polls(axios),
  products: Products(axios),
  sharing: Sharing(axios),
  subscriptions: Subscriptions(axios)
};
